import _toConsumableArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.sub.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map, of } from 'rxjs';
import { memo } from "../util/index.js";
export function referendumIds(instanceId, api) {
  return memo(instanceId, function () {
    var _api$query$democracy;

    return (_api$query$democracy = api.query.democracy) !== null && _api$query$democracy !== void 0 && _api$query$democracy.lowestUnbaked ? api.queryMulti([api.query.democracy.lowestUnbaked, api.query.democracy.referendumCount]).pipe(map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          first = _ref2[0],
          total = _ref2[1];

      return total.gt(first) // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      ? _toConsumableArray(Array(total.sub(first).toNumber())).map(function (_, i) {
        return first.addn(i);
      }) : [];
    })) : of([]);
  });
}